module.exports = __webpack_public_path__ + "static/media/Bank Rakyat.c630ba36.svg";